const mobileSidebarOverflowHidden = () => {

    document.addEventListener('DOMContentLoaded', function () {

        const focusElement = document.querySelector('.ld-focus');
        const sidebar = document.querySelector('#ld-focus-sidebar');
        const mobileNav = document.querySelector('.ld-mobile-nav');

        let touchStartX = 0;

        const enableMobileSwipe = () => {
            if (!sidebar) return;

            sidebar.style.touchAction = 'pan-x';
            sidebar.addEventListener('touchstart', onTouchStart);
            sidebar.addEventListener('touchend', onTouchEnd);
        };

        const disableMobileSwipe = () => {
            if (!sidebar) return;

            sidebar.style.touchAction = '';
            sidebar.removeEventListener('touchstart', onTouchStart);
            sidebar.removeEventListener('touchend', onTouchEnd);
        };

        const onTouchStart = (e) => {
            touchStartX = e.changedTouches[0].screenX;
        };

        const onTouchEnd = (e) => {
            const touchEndX = e.changedTouches[0].screenX;
            const swipeDistance = touchStartX - touchEndX;

            if (swipeDistance > 50) {
                if (focusElement && !focusElement.classList.contains('ld-focus-sidebar-collapsed')) {
                    focusElement.classList.add('ld-focus-sidebar-collapsed');

                    document.body.style.overflow = '';

                    if (mobileNav && mobileNav.classList.contains('expanded')) {
                        mobileNav.classList.remove('expanded');
                    }
                }
            }
        };
        const handleScreenSize = () => {
            if (window.innerWidth < 768) {
                enableMobileSwipe();
            } else {
                disableMobileSwipe();
                document.body.style.overflow = '';
                if (mobileNav) mobileNav.classList.remove('expanded');
            }
        };

        document.body.addEventListener('click', function(e) {
            const target = e.target.closest('.ld-mobile-nav');
            if (!target) return;

            if (focusElement && focusElement.classList.contains('ld-focus-sidebar-collapsed')) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        });

        handleScreenSize();

        window.addEventListener('resize', handleScreenSize);
    });
};

export default mobileSidebarOverflowHidden;
